/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

interface Props {
  className: any;
  text: string;
  hasDiv: boolean;
  options: string[];
  dataSelected: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const Dropdown = ({
  dataSelected,
  className,
  hasDiv = true,
  options = [],
  onChange,
  disabled = false,
}: Props): JSX.Element => {
  return (
    <div className={`dropdown ${className} flex-1`}>
      <div className="frame-2">
        <select className="div-wrapper"
          {...{ disabled }}
          value={dataSelected}
          onChange={onChange}
          required
        >
          {!dataSelected && <option value="">請選擇</option>}
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
      {hasDiv && <div className="text-wrapper-4">Type an error message</div>}
    </div>
  );
};

Dropdown.propTypes = {
  text: PropTypes.string,
  hasDiv: PropTypes.bool,
};
